document.addEventListener('DOMContentLoaded', () => {
  // --- Helper Function ---
  const triggerLoginPopup = () => {
    // Select the login icon in the header
    const loginBtn = document.querySelector('.header-icons-item.account-icon .user');
    if (loginBtn) {
      // console.log('OTP Trigger: Clicking login button');
      loginBtn.click();
    }
  };

  // --- 1. Scroll Trigger (Homepage Only) ---
  // Relies on window.isHomepage being set in theme.liquid
  if (window.isHomepage) {
    // We use sessionStorage so it triggers once per session (tab/window), 
    // satisfying "when user visits" without being annoying on every refresh if they stay.
    const hasScrolledSession = sessionStorage.getItem('otp_scroll_triggered');
    
    if (!hasScrolledSession) {
      const onScroll = () => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight;
        const winHeight = window.innerHeight;
        
        // Calculate scroll percentage (0 to 100)
        const scrollPercent = (scrollTop / (docHeight - winHeight)) * 100;

        if (scrollPercent > 25) {
          triggerLoginPopup();
          sessionStorage.setItem('otp_scroll_triggered', 'true');
          window.removeEventListener('scroll', onScroll);
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  // --- 2. Add to Cart Trigger (Guest Users) ---
  // This script is only loaded if user is NOT logged in (controlled by Liquid),
  // so we don't need an extra check for 'customer' here.
  
  document.addEventListener('click', (e) => {
    // Detect click on Add to Cart buttons
    // Using widely common selectors + specific theme class '.add-to-cart-btn'
    const btn = e.target.closest('button[name="add"], .add-to-cart-btn, .product-form__submit');

    if (btn) {
      // We do NOT preventDefault(). We want the product to be added 
      // and the cart drawer to open as usual.
      
      // We trigger the login popup immediately. 
      // It will likely open over the cart drawer or alongside it.
      triggerLoginPopup();
    }
  }, true); // Capture phase to ensure we catch it even if theme stops propagation (though we aren't stopping it)
});
